/**
 * Единицы учёта на стороне панели.
 *
 * Показ количества — единственное, что фронтенду разрешено делать с числами
 * склада: пересчёты, себестоимость и остатки считает сервер.
 */

export const UNIT_TITLES: Record<string, string> = {
  g: "г",
  kg: "кг",
  ml: "мл",
  l: "л",
  pcs: "шт"
};

/**
 * 1500 г показываются как «1,5 кг».
 *
 * Остаток в граммах читается плохо, а ошибиться в порядке — легко: между
 * «800 г» и «8000 г» на экране разница в один символ, между «800 г» и «8 кг» —
 * очевидная.
 */
export function formatQuantity(quantity: number, unit: string): string {
  const round = (value: number, digits: number) =>
    value
      .toFixed(digits)
      .replace(/\.?0+$/, "")
      .replace(".", ",");

  if (unit === "pcs") return `${round(quantity, 3)} шт`;

  if (Math.abs(quantity) >= 1000) {
    return `${round(quantity / 1000, 3)} ${unit === "g" ? "кг" : "л"}`;
  }

  return `${round(quantity, 1)} ${UNIT_TITLES[unit] ?? unit}`;
}
